import { render, staticRenderFns } from "./tableAgentComm.vue?vue&type=template&id=208ea2a0"
import script from "./tableAgentComm.vue?vue&type=script&lang=js"
export * from "./tableAgentComm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports